"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const logger_1 = require("../logger");
const react_2 = require("@osmosys/react");
exports.ReloadButton = () => {
    const [reloading, toggleReloading] = react_use_1.useToggle(false);
    // Reloading page delay
    react_use_1.useUpdateEffect(() => {
        logger_1.websiteLogger.info('Page marked for reload...', {
            fn: 'useUpdateEffect',
            subModule: 'AppLoader',
        });
        setTimeout(() => {
            logger_1.websiteLogger.info('Reloading...', {
                fn: 'useUpdateEffect',
                subModule: 'AppLoader',
            });
            window.location.reload();
        }, 1000);
    }, [reloading]);
    return (react_1.default.createElement(react_2.OsmosysTooltip, { label: reloading ? 'Refreshing...' : 'Refresh' },
        react_1.default.createElement(reactstrap_1.Button, { size: "sm", color: "link", onClick: () => {
                toggleReloading();
            } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSync, size: "lg", spin: reloading, fixedWidth: true }))));
};
//# sourceMappingURL=ReloadButton.js.map